"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetOlapicInfo = void 0;
var _fetching = require("@ori/fetching");
var _presentationHttp = require("@ori/presentation-http");
var _models = require("../models");
var _utils = require("../utils");
var _externalUrl = require("./externalUrl");
/* istanbul ignore file @preserve --api */

/**
 * Fetches Olapic information from the API. The API key to authenticate the request.
 */
const fetchOlapicInfo = async apiKey => {
  const {
    apiDomain,
    apiVersion,
    wrapResponses
  } = _externalUrl.baseConfig;
  const url = `${apiDomain}?auth_token=${apiKey}&version=${apiVersion}&wrap_responses=${wrapResponses}`;
  return (0, _externalUrl.getExternalUrl)(url, {
    responseType: 'json'
  });
};

/**
 * Retrieves Olapic information either from local storage or the API.
 * If the information in local storage is outdated or doesn't exist, it fetches from the API.
 * The API key to authenticate the request.
 */
const getOlapicInfo = async apiKey => {
  const defaultInfo = {
    created: Date.now(),
    apiKey,
    customerId: '',
    language: ''
  };
  const expireTime = (0, _externalUrl.getExpireTime)(_externalUrl.cacheMinutes.info);
  const localStorageData = (0, _utils.loadFromLocalStorage)(_utils.LocalStorageNames.info);
  if (localStorageData?.apiKey === apiKey && localStorageData.created > expireTime) {
    return localStorageData;
  }
  const response = await fetchOlapicInfo(apiKey);
  return (0, _presentationHttp.validateResponse)(response, {
    schema: _models.olapicInfoSchema,
    onError: () => defaultInfo,
    onSuccess: ({
      data
    }) => {
      const result = data.data;
      return {
        ...defaultInfo,
        customerId: result._embedded.customer.id,
        language: result._embedded.customer.language
      };
    }
  });
};
const useGetOlapicInfo = ({
  apiKey
}) => {
  const {
    data,
    error
  } = (0, _fetching.useSWR)(apiKey || null, async () => getOlapicInfo(apiKey), {
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    onSuccess: olapicInfo => {
      if (olapicInfo.customerId && olapicInfo.language) {
        (0, _utils.saveToLocalStorage)(_utils.LocalStorageNames.info, olapicInfo);
      }
    }
  });
  return {
    data,
    isLoading: data === undefined && error === undefined,
    isError: Boolean(error)
  };
};
exports.useGetOlapicInfo = useGetOlapicInfo;
